export function useHomeLayoutMode() {
  const { signatureHost } = useRuntimeConfig().public
  const { host } = useRequestURL({ xForwardedHost: true })

  const isSignatureHost = host === signatureHost

  return { isSignatureHost }
}
